<template>
  <div class="page-top">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="text-center fw-bold mb-5">
            メディア掲載
          </h2>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_01.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                カジサポ
              </h5>
              <p class="card-text review-card-text">
                宜しくお願い致します！
                勝winカジノは入金不要ボーナスや、入金ボーナスの内容が他のオンラインカジノと比較すると魅力的で、それだけではなく、リベートや勝ポイント等、普段から楽しめるプロモーションを提供しています。最近では、新しいゲーム（パチンコ、パチスロ）プロバイダーの導入や、新しい入出金方法としてベガウォレットの導入、出金時間の短縮等、常にユーザーのニーズに併せてサービスの改善しているオンラインカジノです。
                カジサポはそのようなオンラインカジノとアフィリエイト出来ることを光栄に思っております。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://casisapo.com/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/oncasy_logo.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                ONCASY
              </h5>
              <p class="card-text review-card-text">
                勝winは新規カジノながら安定した入出金ができ、サイトの使い勝手も良く、今流行りのオンカジでパチンコ・パチスロをプレイすることも可能です！
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://oncasy.com/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_03.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                オンカジファイターのカジノ紹介
              </h5>
              <p class="card-text review-card-text">
                勝winカジノはプレイヤーへの還元率がとても高いサイトだと思います。出金も早く、ボーナスの条件も魅力的です。プレーヤーのニーズにしっかりと答えようとされている印象です。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://casinohunter777.com" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_04.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                カジノグラシ
              </h5>
              <p class="card-text review-card-text">
                他社と比較しても還元率が高く、プレイヤーファーストな条件のボーナスが多いので、今後飛躍していくオンラインカジノになるでしょう。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://casino-gurashi.com/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4 ">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_05.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                オンカジクリプト
              </h5>
              <p class="card-text review-card-text">
                勝win様は通常のカジノゲームだけではなくオンラインパチンコ・パチスロにも対応したギャンブルサイトです。仮想通貨による安全で高速な入出金も利用でき、充実したVIPプログラムも導入されているとても魅力的なオンラインカジノです。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://crypto-oncasi.com/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4 ">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_06.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                カジ通
              </h5>
              <p class="card-text review-card-text">
                勝WINカジノは名前の通り、プレイヤーが勝ちやすい環境でプレイできるオンラインカジノだと思います。<br>
                魅力的なプロモーションが多いので、興味があればぜひ覗いてみてください。
                また、アフィリエイトに関しても担当者が親切で、安心して紹介できると思います。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://casinotsu.com/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4 ">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_07.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                オンカジギャンブラーの酒場
              </h5>
              <p class="card-text review-card-text">
                当サイト「オンカジギャンブラーの酒場」では勝WINカジノ様を紹介しています。プレオープン段階から高額な入金不要ボーナスを提供や、高還元率のVIPプログラムの設定など、かなり攻めたプロモーション施策が特にカジノユーザーに好評です。加えてパチンココンテンツの導入など、さらなる魅力アップに貪欲な姿勢が、とても頼もしい限りです。勝WINカジノ様の魅力を多くのユーザーに届けられるよう、微力ながらお力添えさせていただきます。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://www.onlinecasino-gambler.com/no-deposit-bonus/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4 ">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_08.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                オンカジギャンブル情報
              </h5>
              <p class="card-text review-card-text">
                オンカジギャンブル情報は、オンラインカジノに関する最新の情報を常に更新して発信しているサイトです。<br>
                入金不要ボーナス情報に特に力を入れており、人気カジノからマイナーなカジノまで詳しく紹介しています。<br>
                勝WINカジノ様とオンカジギャンブル情報はアフィリエイトチームを通じて提携しています。<br>
                勝WINカジノ様は、我々のニーズを的確に把握し、最適な情報を提供することに全力を注いでくれています。<br>
                また、常に透明性の高いコミュニケーションを心掛け、クライアントとの信頼関係を築いてくださっている素晴らしいオンラインカジノです。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://comp-liance.co.jp/onlinecasino/casino/nyuukinfuyou/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4 ">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_09.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                オンカジ入金不要ボーナス
              </h5>
              <p class="card-text review-card-text">
                勝WINカジノは新規カジノの中でもボーナスやプロモーションが豊富で登録者数が伸びている勢いのあるカジノの1つです。ユーザーファーストで真摯に向き合っているのが分かるので当サイト「オンカジ入金不要ボーナス情報局」としても一押しのカジノです。これからもお互いより良い関係で協力させていただければと思います。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://compaffi.com/onlinecasino/no-deposit-bonus/all-no-deposit-bonus/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_10.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                入金不要ボーナスどっとこむ
              </h5>
              <p class="card-text review-card-text">
                勝WINカジノは、高級あるサイトデザインが魅力的なオンラインカジノです。<br>
                カジノやライブ&テーブルはもちろん、日本人が好きなパチスロ・パチンコがプレイできるので楽しく遊べると思います。<br>
                また、アフィリエイト担当者様もとても良い方なので、アフィリエイターとして活動する際も紹介しやすいでしょう。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://oncasi-bonus.com/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_11.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                オンカジモンスター
              </h5>
              <p class="card-text review-card-text">
                膨大な数あるオンラインカジノの中でも、安心してプレイできる優良なオンラインカジノはほんのひと握りです。<br>
                その中でも勝WINは初心者から上級者までの幅広い層に対応したサービスの提供や改善が日々行われており、今後も様々な特典やプロモーションが期待できるオンラインカジノです。<br>
                ・はじめてのオンラインカジノで、どのオンラインカジノを利用したらいいのか分からない<br>
                ・失敗しないオンラインカジノを知りたい<br>
                という方は、まずは勝WINで新規会員登録をすることをおすすめします。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://waseda-edge.jp/no-deposit-bonus/all-casino-no-deposit-bonus/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_12.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                オンラインカジノボーナス最新情報部【カジボ】
              </h5>
              <p class="card-text review-card-text">
                勝winカジノは各種ボーナスがとても魅力的です。入金不要ボーナスや、入金ボーナス等、プレイヤーにとってお得すぎるプロモーションがたくさんあるので、ゲットして損はありません！また、安心安全の入出金・高い還元率・新ゲームのプレイなど、あなたにとって充実した体験ができることは間違いなしです！
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://ekimarushinosaka.com/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_13.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                オンカジタウン
              </h5>
              <p class="card-text review-card-text">
                勝winとパートナー関係を結べたことを嬉しく思います。日本市場を最重要視しており、日本人プレイヤーにも受け入れやすい設計と魅力的なボーナスが用意されています。これから先、人気のオンラインカジノへと成長していくことに期待します。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://oncasitown.com/onlinecasinosite/katsuwin" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_14.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                GOスタッツカジノ
              </h5>
              <p class="card-text review-card-text">
                勝WINカジノは、幅広いゲームセレクションと豊富なプロモーションで知られるオンラインカジノです。定期的に開催されるトーナメントや限定プロモーションにより、常に新鮮な楽しみを提供しています。さらに、VIPプログラムでは専用の特典やサービスが用意されており、ハイローラーのニーズにも応えています。勝WINカジノは、多くのプレイヤーにとって信頼と満足度の高い選択肢となっています。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://gostats.jp/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-4">
          <div class="card h-100 review-card">
            <img src="@/assets/images/icon_img_15.png" class="card-img-top review-icon mx-auto" alt="...">
            <div class="card-body">
              <h5 class="card-title text-center fw-bold my-4 review-card-title">
                カジノクエスト
              </h5>
              <p class="card-text review-card-text">
                勝winは入出金のスピードも安定しておりオススメです。<br>
                スロットの種類も豊富で4号機のパチスロなども打てるのでカジノ初心者の人でも分かりやすく、使いやすいカジノになります。
              </p>
            </div>
            <div class="card-footer review-card-ft">
              <a href="https://simulationgame.jp/" target="_blank" class="btn btn-primary btn-golden d-block btn-review mx-auto">サイトを見る</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {

  },
  created() {
  },
  methods: {

  }
}
</script>
